import $ from 'jquery'
import '../utils/isonscreen'

const BUTTON_SELECTOR = '.btn-load-more'
// eslint-disable-next-line
const BUTTON_AUTOCLICK_SELECTOR = '.btn-load-more--autoclick'
const CONTAINER_SELECTOR = '.container-load-more'

class LoadMoreButton {
  constructor(el) {
    this.el = el
    this.containerSelector = $(this.el).data('container') || CONTAINER_SELECTOR
    this.container = $(this.containerSelector)[0]
    this.lastScrollTop = 0
    this.delta = 5

    this.init()
  }

  init() {
    this.listen()

    return this
  }

  listen() {
    $(this.el).on('click', this.handleLoadMore.bind(this))

    return this
  }

  handleScroll(e) {
    let st = $(e.currentTarget).scrollTop()

    if (Math.abs(this.lastScrollTop - st) <= this.delta) return

    if (st > this.lastScrollTop) {
      if (!$(this.el).prop('disabled')) {
        let end = $(this.container).offset().top + $(this.container).height()
        let viewEnd = st + $(window).height()
        let distance = end - viewEnd

        if (distance < 300) {
          $(this.el).click()
        }
      }
    }

    this.lastScrollTop = st
  }

  handleLoadMore(e) {
    e.preventDefault()

    this.lock()

    $.ajax({
      type: $(this.el).data('method') || 'GET',
      url: $(this.el).attr('href'),
      data: $(this.el).data('data'),
      success: this.submitted.bind(this),
      error: this.failed.bind(this),
    })
  }

  submitted(data) {
    const $dataContainer = $(data).find(this.containerSelector)
    const pagination = $dataContainer.data('pagination')

    this.appendItems($dataContainer.html())

    if (pagination.next) {
      $(this.el).attr('href', $dataContainer.data('next'))

      this.unlock()
    } else {
      this.hide()
    }
  }

  failed($xhr) {
    console.log($xhr)

    this.unlock()
  }

  appendItems(items) {
    const $items = $(items).hide()
    const scrollTop = $(window).scrollTop()
    $(this.container).append($items)
    $items.slice().slideDown()
    $(window).scrollTop(scrollTop)
  }

  hide() {
    $(this.el).fadeOut('slow')

    return this
  }

  lock() {
    $(this.el)
      .prop('disabled', true)
      .addClass('btn--loading')

    return this
  }

  unlock() {
    $(this.el)
      .prop('disabled', false)
      .removeClass('btn--loading')

    return this
  }

  element() {
    return this.el
  }
}

export default {
  init() {
    $(BUTTON_SELECTOR).each((index, item) => new LoadMoreButton(item))
  },
}
